// Recursively Object.freeze a value and everything reachable from it.
//
// Used on large, read-only API result sets before handing them to Vue: a frozen
// object is skipped by Vue's reactive() conversion, so freezing thousands of rows
// (and their nested company/warnings/etc. objects) avoids the deep-proxy overhead
// that otherwise makes big tables sluggish. Only use this on data the UI never
// mutates after load.

export function deepFreeze(value) {
    if (value === null || typeof value !== 'object' || Object.isFrozen(value)) {
        return value
    }

    // Freeze the container first so a (pathological) self-reference terminates.
    Object.freeze(value)

    if (Array.isArray(value)) {
        for (const item of value) {
            deepFreeze(item)
        }
    } else {
        for (const key of Object.keys(value)) {
            deepFreeze(value[key])
        }
    }

    return value
}
